import * as React from "react"

function SvgTimeClockCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 50 50"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.083}
      >
        <path d="M24.998 1.044c13.231 0 23.958 10.727 23.958 23.958 0 13.231-10.727 23.958-23.958 23.958-13.231 0-23.958-10.727-23.958-23.958 0-13.231 10.727-23.958 23.958-23.958z" />
        <path d="M25 13.544v11.458L37.5 36.46" />
      </g>
    </svg>
  )
}

export default SvgTimeClockCircle
